import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectCategory {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectCategory = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectCategory) => {
  const itemList = useStoreState((state) => state.student.studentCategoryList);
  const itemListFetch = useStoreActions((state) => state.student.fetchstudentCategory);

  React.useEffect(()=>{
    itemListFetch()
  },[])
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Category"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Category</Option>
      )}
    </Select>
  );
};
